<template>
	<div>
		<a-modal v-show='!ishand' id='handlook' width='30rem' v-model="visible" on-ok="handleOk1"
			v-dragModal
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 28rem;text-align: center;">
					外出記錄
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="border-radius: 0 0 10px 10px;
    padding: 1rem;
    border-radius: 0px 0px 10px 10px;
    width: 30rem;
    margin: 0px auto 1rem;">
				<!--  v-if='false' -->
				<div style="margin: 0 auto;padding: 1.6rem 1rem;width: 100%;background: #fff;">
						<a-row>
							<a-col :span='14'>
								<a-col :span='8' class='titName' v-html='"員工姓名&nbsp;&nbsp;:"'></a-col>
								<a-col :span='16' class='comname'>{{formview.realname}}
									<img v-if='formview.sex == 1' :src="require('@/image/lea/man.png')" alt="">
									<img v-if='formview.sex == 2' :src="require('@/image/lea/woman.png')" alt="">
								</a-col>
							</a-col>
							<a-col :span='10'>
								<a-col :span='11' class='titName'  v-html='"申請日期&nbsp;&nbsp;:"'></a-col>
								<a-col :span='13' class='comname'>{{formview.createtime}}</a-col>
							</a-col>
							<a-col :span='14'>
								<a-col :span='8' class='titName ' v-html='"部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;門&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='16' class='comname'>{{formview.department}}</a-col>
							</a-col>
							<a-col :span='10'>
								<a-col :span='11' class='titName ' v-html='"職&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='13' class='comname'>{{formview.job}}</a-col>
							</a-col>
							<a-col :span='14'>
								<a-col :span='8' class='titName ' v-html='"外出時間&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='16' class='comname'>{{formview.gooutdate}}</a-col>
							</a-col>
							<a-col :span='24'>
								<a-col :span='5' class='titName ' v-html='"外出地點&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='19' class='comname padleft'>{{formview.address}}</a-col>
							</a-col>
							<a-col :span='24'>
								<a-col :span='5' class='titName ' v-html='"外出事由&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='19' class='comname padleft'>{{formview.cause}}</a-col>
							</a-col>
							<a-col :span='24'>
							<div style="margin: 1rem auto 0;width: 60%;">
								<div style="width: 100%;height: .5rem;border-bottom: 1px solid rgb(12, 139, 151);"></div>
								 <span style='color: rgb(12, 139, 151);font-size: .8rem;position: relative;
								left: 37%;top: -.7rem;display: inline-block;background-color: #fff;padding: 0 .3rem;'>外出總結</span>
							</div>
								</a-col>
							<a-col :span='24'>
								<a-col :span='5' class='titName '  v-html='"外出總結&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='19' class='comname padleft'>{{formview.summarize}}</a-col>
							</a-col>
							<a-col :span='24'>
								<a-col :span='5' class='titName ' v-html='"名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;片&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='19' class='comname padleft'>
									<img v-if='formview.cardpic' :src="formview.cardpic" alt=""
									 style="margin-top: .3rem;height: 16rem;width: 19.5rem;">
									<!-- form.cardpic -->
								</a-col>
							</a-col>
						</a-row>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';

	export default {
		props: ['openstatic', 'applyid'],
		components: {},
		data() {
			return {
				formview: {
					createtime: "23/06/2021",
					department: "行政",
					position: "前台客服",
					realname: "song",
					sex: 0,
					address: '', // 地址
					cause: '', // 事由
				},
				visible: true,
				ishand: false,
				form: {
					"token": "",
					"summarize": "",
					"cardpic": "", //base64
					"applyid": '',
					issave: ''
				},
			}
		},
		mounted() {
			this.handimg()
		},
		methods: {
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.applyid,
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data
						this.form.summarize = res.data.summarize
						this.form.cardpic = res.data.cardpic

						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	#handlook {

		.ant-divider-horizontal.ant-divider-with-text-center::before,
		.ant-divider-horizontal.ant-divider-with-text-left::before,
		.ant-divider-horizontal.ant-divider-with-text-right::before,
		.ant-divider-horizontal.ant-divider-with-text-center::after,
		.ant-divider-horizontal.ant-divider-with-text-left::after,
		.ant-divider-horizontal.ant-divider-with-text-right::after {
			border-color: #0c8b97;
		}


		.ant-fullcalendar-today .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
			box-shadow: 0 0 0 1px red inset;
		}

		.ant-fullcalendar-selected-day .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
			background: red;
		}

		.ant-radio-group-small {
			display: none;
		}

		.ant-fullcalendar-header {
			.ant-fullcalendar-year-select {
				width: 5rem;
				display: inline-block;
			}

			.ant-fullcalendar-month-select {
				width: 5rem;
				display: inline-block;
			}
		}

		.myauto {
			margin: 0 7rem;
		}

		.titName {
			font-size: .9rem !important;
			color: #000;
			height: 2rem;
		}

		.comname {
			font-size: .8rem !important;
		}
		
		.padleft{
			// padding-left: .8rem;
			left: -.4rem;
			position: relative;
		}
		
		.ant-modal {
			top: 15vh;
		}

		.warp_min {
			vertical-align: top;
			width: 64%;
			height: 3rem;
			line-height: 3rem;
			font-size: .8rem;
			padding: .7rem 0;
			display: inline-block;
		}

		.warp_titlis {
			margin-right: .1rem;
			color: #000;
			width: 34.5%;
		}


		.warp-right {
			text-align: right;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
			width: 4rem;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}
	}
</style>
